import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import Container from '@mui/material/Container';

import SectionTitle from '@/components/SectionTitle/SectionTitle';
import usePageTitle from '@/hooks/usePageTitle';
import EnvioFlex from '@/sections/plugins/EnvioFlex';

const EnvioFlexPage = () => {
  usePageTitle('Integraciones - Mercado Libre Flex');

  return (
    <Container maxWidth="xxl">
      <SectionTitle title="Mercado Libre Flex" mt={5}>
        <LocalShippingOutlinedIcon fontSize="large" />
      </SectionTitle>

      <EnvioFlex />
    </Container>
  );
};
export default EnvioFlexPage;
